import React from 'react';
import { useDispatch } from 'react-redux';
import { sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { showErrorBanner } from '@utils/application';
import { formatTagResponseData, checkDoesTagExistInResults } from './helpers';
import { SelectableTagWrapper, SelectableTagsWrapper, SelectableTagsPositionWrapper } from './styles';
import { Body7 } from '@ui';
import { Container } from '@ui';
import { SelectableTagResult } from './SelectableTagResult';

function generateKeyForTag(tag) {
  if (tag.doc_tag_id) {
    return 'doc_tag:' + tag.doc_tag_id;
  } else if (tag.company_id) {
    return 'company:' + tag.company_id;
  } else {
    return 'id:' + tag.id;
  }
}

export const SelectableTagResults = ({ isQuerying, query, results, onSelectTag, enableCreateTag }) => {
  const dispatch = useDispatch();
  const showCreateTagAction = !checkDoesTagExistInResults(query, results) && enableCreateTag;

  const onCreateTag = async () => {
    const URL = `v1/genai/documents/tags`;
    const form = {
      name: query,
    };
    const { status, data, error } = await sendApiRequest('post', URL, form);
    logNetRequest(status, data, error);
    if (status === 200) {
      onSelectTag(formatTagResponseData(data));
    } else {
      if (data?.error === 'Doc tag with that name or symbol already exists') {
        showErrorBanner('This company already exists, please refresh the page and try again.', null, dispatch);
      } else {
        showErrorBanner('Something went wrong, please try again.', null, dispatch);
      }
    }
  };

  if (!results || !query || query === '' || isQuerying) return null;
  return (
    <SelectableTagsWrapper>
      <SelectableTagsPositionWrapper>
        {results?.map((r, i) => (
          <SelectableTagResult key={generateKeyForTag(r) + '-' + i} value={r} onClick={onSelectTag} />
        ))}
        {results?.length === 0 && (
          <SelectableTagWrapper onClick={() => null}>
            <Container vertical={4}>
              <Body7>No results for "{query}"</Body7>
            </Container>
          </SelectableTagWrapper>
        )}
        {showCreateTagAction && (
          <SelectableTagWrapper onClick={onCreateTag}>
            <Container vertical={4}>
              <Body7 bold>+ CREATE "{query}"</Body7>
            </Container>
          </SelectableTagWrapper>
        )}
      </SelectableTagsPositionWrapper>
    </SelectableTagsWrapper>
  );
};
